function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
const colors = {
  error: "var(--error)",
  warning: "var(--warning)",
  information: "var(--info)",
  info: "var(--info)",
  success: "var(--success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-on-color)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const InlineLoaderIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Loading",
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Loading"
}, "Loading"), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  strokeWidth: 0.8
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  stroke: "#E4E4E4",
  d: "M7.638 1.327C4.09 2.383 1.478 5.351.934 9.051c-.413 2.807.584 5.55 2.457 7.511.324.34.9-.437.684-.664-1.768-1.853-2.688-4.501-2.15-7.121.656-3.182 3.045-5.902 6.25-6.61 6.858-1.514 12.144 5.821 8.722 12.01a.36.36 0 0 0 .125.487l.203.118a.36.36 0 0 0 .485-.135c1.769-3.196 1.665-7.237-.564-10.125-2.191-2.84-5.99-4.241-9.508-3.195z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3D84FF",
  stroke: "#3D84FF",
  d: "M3.67 16.382c2.688 2.545 6.565 3.322 10.041 1.944 2.638-1.046 4.514-3.28 5.277-5.884.131-.45-.83-.56-.918-.26-.72 2.458-2.554 4.579-5.092 5.422-3.083 1.024-6.633.314-8.849-2.107C-.61 10.315 3.1 2.069 10.17 1.939a.36.36 0 0 0 .36-.352v-.235A.358.358 0 0 0 10.17 1c-3.652.066-7.1 2.176-8.486 5.55-1.364 3.319-.679 7.31 1.986 9.833z"
})));
export const SuperSmallInlineLoaderIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Loading",
  width: "15px",
  height: "14px",
  viewBox: "0 0 15 14",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Loading"
}, "Loading"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  x1: "18.1521429%",
  y1: "88.5178571%",
  x2: "81.9385714%",
  y2: "12.5%",
  id: "linearGradient-1"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFFFFF",
  offset: "0%"
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3C6BB4",
  offset: "100%"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Page-1-",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "036---CC-Statuses",
  transform: "translate(-1519.000000, -662.000000)",
  fill: "url(#linearGradient-1)"
}, /*#__PURE__*/React.createElement("g", {
  id: "table",
  transform: "translate(395.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "ROW3",
  transform: "translate(0.000000, 201.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "loader",
  transform: "translate(1124.000000, 19.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Shape"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.128426,14 C3.228426,14 0.128426,10.9 0.128426,7 C0.128426,3.3 3.428426,0 7.128426,0 C10.828426,0 14.128426,3.3 14.128426,7 C14.128426,10.9 11.028426,14 7.128426,14 Z M7.128426,1 C4.028426,1 1.128426,3.9 1.128426,7 C1.128426,10.3 3.828426,13 7.128426,13 C10.428426,13 13.128426,10.3 13.128426,7 C13.128426,3.9 10.228426,1 7.128426,1 Z",
  fillRule: "nonzero"
}))))))));
export const TableInlineLoaderIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  role: "img",
  "aria-labelledby": "Loading",
  width: "22px",
  height: "22px",
  viewBox: "0 0 22 22",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "Loading"
}, "Loading"), /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1022.000000, -739.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(395.000000, 442.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 273.000000)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(627.000000, 24.000000)"
}, /*#__PURE__*/React.createElement("circle", {
  className: "primary-fill",
  fill: "#006DC9",
  cx: 11,
  cy: 11,
  r: 11
}), /*#__PURE__*/React.createElement("circle", {
  className: "secondary-fill",
  fill: "#F4FBFF",
  cx: 10.5,
  cy: 11.5,
  r: 9.5
})))))));